import { AriaLiveAnnouncer } from 'aria-announcer-js';

const announcer = new AriaLiveAnnouncer({ politeness: 'polite', processingTime: 3000 });

export default announcer;
